<template>
    <v-col :cols="cols">
        <v-select
            v-model="selected"
            :items="items"
            :label="$t('lang_GENERIC_ACTION_BULK_FILE_IMPORT_REPORT')"
            @input="run"
            menu-props="offset-y, offset-overflow"
            :outlined="true"
            :hideDetails="true"
            :alvqa="alvqa + '-list-import-dropdown'"
            :no-data-text="$t('lang_GENERAL_CAPTION_NO_DATA_AVAILABLE')"
            @click:clear="resetVal()"
        >
            <template v-slot:item="{ item }">
                <div :alvqa="item.alvqa">
                    {{ item.text }}
                </div>
            </template>
            <template v-slot:selection="{ item }">
                <div class="text-no-wrap text-truncate" :alvqa="item.alvqa">
                    {{ item.text }}
                </div>
            </template>
        </v-select>
    </v-col>
</template>

<script>
import VSelect from 'vuetify/es5/components/VSelect'
export default {
    name: "ReportButton",
    extends: VSelect,
    props: {
        cols: {
            type: String | Number,
            default: "3"
        },
        alvqa: {
            type: String,
            default: ''
        },
        context: String
    },
    computed: {
        selected: {
            get() { return this.$store.getters['getSelected'+this.context] },
            set(selected) { this.$store.commit('setSelected'+this.context, selected) }
        },
    },
    methods: {
        run() {
            this.$store.dispatch('do'+this.context)
        },
        async resetVal() {
            await this.$nextTick()
            this.selected = null
        }
    }
}
</script>

<style>

</style>